const DEFAULT_BUNNY_LIBRARY_ID = "585118";
const DEFAULT_BUNNY_PLAYER_HOST = "iframe.mediadelivery.net";

const bunnyLibraryId = import.meta.env.VITE_BUNNY_LIBRARY_ID?.trim() || DEFAULT_BUNNY_LIBRARY_ID;
const bunnyPlayerHost = import.meta.env.VITE_BUNNY_PLAYER_HOST?.trim() || DEFAULT_BUNNY_PLAYER_HOST;
const videoIdPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const bunnyPlayerHosts = new Set(["iframe.mediadelivery.net", "player.mediadelivery.net"]);

type PlayerOptions = {
  autoplay?: boolean;
  startTime?: number;
};

export function buildBunnyPlayerUrl(value: string | null | undefined, options: PlayerOptions = {}) {
  const source = value?.trim();
  if (!source) return null;

  let playerUrl: URL;
  if (videoIdPattern.test(source)) {
    playerUrl = new URL(`https://${bunnyPlayerHost}/embed/${bunnyLibraryId}/${source}`);
  } else {
    try {
      playerUrl = new URL(source);
    } catch {
      return null;
    }

    if (!bunnyPlayerHosts.has(playerUrl.hostname) || !playerUrl.pathname.startsWith("/embed/")) {
      return null;
    }

    playerUrl.hostname = bunnyPlayerHost;
  }

  playerUrl.searchParams.set("autoplay", options.autoplay ? "true" : "false");
  playerUrl.searchParams.set("loop", "false");
  playerUrl.searchParams.set("muted", "false");
  playerUrl.searchParams.set("preload", "true");
  if ((options.startTime ?? 0) > 0) playerUrl.searchParams.set("t", String(Math.floor(options.startTime!)));
  else playerUrl.searchParams.delete("t");

  return playerUrl.toString();
}
